import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Bank",
  "use": "Bank-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Bank\">\n<path d=\"M7 10H4V17H7V10Z\" fill=\"#002B48\" />\n<path d=\"M13.5 10H10.5V17H13.5V10Z\" fill=\"#323232\" />\n<path d=\"M22 19H2V22H22V19Z\" fill=\"#323232\" />\n<path d=\"M20 10H17V17H20V10Z\" fill=\"#323232\" />\n<path d=\"M12 1L2 6V8H22V6L12 1Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol